// src/components/claims/ClaimRow.jsx
// One claim: status chip, the sentence of the FINAL text with the fact marked, then
// what backs it — the row's OWN source (never looked up), the quote, the corrected
// value, the brief field or the brand entry.
import React from 'react';
import { useTranslation } from 'react-i18next';
import StatusChip from './StatusChip.jsx';
import HighlightedText from './HighlightedText.jsx';
import { STATUS_TONE, safeHttpUrl } from './claimsModel.js';
import { COLORS } from '../../constants/theme.js';

const HIGHLIGHT_TONE = { verde: 'verde', errore: 'errore', attenzione: 'attenzione', neutro: 'attenzione' };

function SourceLine({ source, tr, muted }) {
  if (!source?.title) return null;
  const href = safeHttpUrl(source.url);
  return (
    <div style={{ fontSize: '11.5px', color: muted }}>
      {tr('claims.sourceLine')}
      {href
        ? <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: COLORS.accent }}>{source.title}</a>
        : <>{source.title} {tr('claims.unlinked')}</>}
    </div>
  );
}

export default function ClaimRow({ claim, t = {} }) {
  const { t: tr } = useTranslation('outputs');
  const muted = t.textMuted || COLORS.textSecondary;
  const tone = HIGHLIGHT_TONE[STATUS_TONE[claim.status] || 'neutro'];
  const correction = claim.correction === 'rimuovere'
    ? tr('claims.correctionRemove')
    : claim.correction ? tr('claims.correctionLine', { value: claim.correction }) : null;
  return (
    <li style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '8px 0' }}>
      <div><StatusChip status={claim.status} /></div>
      <div style={{ fontSize: '13px', lineHeight: 1.5, color: t.text || COLORS.ink }}>
        <HighlightedText text={claim.text} highlight={claim.highlight} tone={tone} />
      </div>
      <SourceLine source={claim.source} tr={tr} muted={muted} />
      {claim.evidence_quote && (
        <div style={{ fontSize: '11.5px', color: muted, fontStyle: 'italic' }}>
          {tr('claims.quoteLine', { quote: claim.evidence_quote })}
        </div>
      )}
      {correction && <div style={{ fontSize: '11.5px', color: t.text || COLORS.ink }}>{correction}</div>}
      {claim.status === 'FROM_BRIEF' && claim.brief_field && (
        <div style={{ fontSize: '11.5px', color: muted }}>
          {tr('claims.briefLine', { field: tr(`claims.briefField.${claim.brief_field}`, { defaultValue: claim.brief_field }) })}
        </div>
      )}
      {claim.status === 'FROM_BRAND' && claim.brand_claim?.label && (
        <div style={{ fontSize: '11.5px', color: muted }}>
          {tr('claims.brandLine', {
            label: claim.brand_claim.label,
            category: tr(`claims.brandCategory.${claim.brand_claim.category}`, { defaultValue: claim.brand_claim.category || '' }),
          })}
        </div>
      )}
    </li>
  );
}
